import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import packageJson from '@root/package.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  appVersion = packageJson.version;
}
